import React, { Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropdownListItem from "../DropdownContainer/DropdownListItem";

import { IMAGE_URLS } from "../../../constants";

const { STAR } = IMAGE_URLS;

function UserGroupRolesUpgrade(props) {
  const { type, listItems, templateId, docID, id } = props;

  return (
    <Fragment>
      <ul className="dropdowncontainer-list">
        {type === "userGroups" ? (
          <div
            onClick={() =>
              props.togglePopUp("showUpgradePopop", true, props.featureName)
            }
            onKeyPress={() => {}}
            role="button"
            tabIndex="0"
            className="add-another-usergroup-upgrade-wrapper">
            <i className="plusicon" data-test="dropdowncontainer-new-user-btn">
              <FontAwesomeIcon icon={["far", "plus"]} className="" />
            </i>
            <div className="add-another-user-btn">
              <div className="add-another-user-title">
                New users groups <img src={STAR} alt="star" />
              </div>
            </div>
          </div>
        ) : (
          listItems &&
          listItems.map(item => (
            <DropdownListItem
              docID={docID}
              templateId={templateId}
              className="dropdowncontainer-list-item"
              type={type}
              item={item}
              key={`${item.id}-${type}listitem${id}`}
              changeDocumentStatus={props.changeDocumentStatus}
              onKeyPress={() => {}}
            />
          ))
        )}
      </ul>
    </Fragment>
  );
}

export default UserGroupRolesUpgrade;
